<template>
  <modal-padrao
    ref="modal-visualizar-mensagem"
    :titulo="$t('modulos.orcamentos.modal_visualizar_mensagem.titulo')"
    max-width="80%"
    :icone-cancelar="false"
    :titulo-cancelar="$t('geral.botoes.voltar')"
    :mostra-botao-salvar="false"
  >
    <div class="my-3">
      <v-chip class="mr-1" small>
        {{ $t('modulos.orcamentos.tabela.sequencia') }}: {{ badges?.sequencia }}
      </v-chip>
      <v-chip class="mx-1" small>
        {{ $t('modulos.orcamentos.tabela.nome') }}:{{ badges?.nome }}
      </v-chip>
      <v-chip class="ml-1" small>
        {{ $t('modulos.orcamentos.tabela.classificacao') }}:
        {{ badges?.classificacao }}
      </v-chip>
    </div>
    <p class="font-weight-bold text-body-2">
      {{ mensagem?.descricao }}
    </p>
  </modal-padrao>
</template>
<script>
export default {
  data() {
    return {
      mensagem: null,
      badges: {},
    };
  },
  methods: {
    abrirModal: function (mensagem) {
      this.badges = {
        sequencia: mensagem?.sequencia,
        nome: mensagem?.titulo,
        classificacao: mensagem?.descricaoClassificacao,
      };
      this.mensagem = mensagem;
      this.$refs['modal-visualizar-mensagem'].abrirModal();
    },
  },
};
</script>
